import React, { useState, useEffect } from 'react';
import { GoogleMap, useLoadScript,  Marker } from "@react-google-maps/api";
import { getMapa } from 'services/api';

const SimpleMap = (props) => {
    const { directions } = props;
    const [latitude, setLatitude] = useState(0);
    const [longitude, setLongitude] = useState(0);

    useEffect(() => {
      
        if (directions !== '') {

            getMapaApi(directions);
        }
    }, [directions]);

    const { isLoaded } = useLoadScript({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDroBmIVH3yu2mKcrkxZ5dLhKFkbHAxz7s",
    });

    const [center, setCenter] = useState({ lat: latitude, lng: longitude });
    const [markers, setMarkers] = useState([]);
    useEffect(() => {
       
        if(latitude!==0 && longitude!==0){
    
            setCenter({ lat: latitude, lng: longitude });
            setMarkers([{ lat: latitude, lng: longitude }]);
        }
    }, [latitude, longitude]);

    const getMapaApi = async (direccion) => {
   
            if(direccion){
                getMapa(direccion)
                .then(res=>{
                    
                    setLatitude(res.data.results[0].geometry.location.lat);
                    setLongitude(res.data.results[0].geometry.location.lng);
                })
                .catch(e => console.error(e))
                .finally(f=>{

                })
            }
    };

    const containerStyle = {
        width: '100%',
        height: '400px'
    };

    return (
        <React.Fragment>
            {isLoaded && (
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={16}
                   // options={{ mapId }}
                >
                      {markers.map((marker, index) => (
                        <Marker key={index} position={{ lat: marker.lat, lng: marker.lng }} />
                    ))}
                </GoogleMap>
            )}
        </React.Fragment>
    );
};

export default SimpleMap;
